/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { BORDER_WIDTH } from '@atlaskit/avatar';
import Button from '@atlaskit/button/custom-theme-button';
import { token } from '@atlaskit/tokens';

import { MAX_ASSIGNEES_C0UNT } from '../../constants';

export const AssigneesWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  '&:not(:empty)': {
    paddingRight: token('space.200'),
    '&::before': {
      content: "''",
      position: 'absolute',
      top: '50%',
      height: token('space.200'),
      transform: 'translateY(-50%)',
      width: '1px',
      right: 0,
      background: token('color.background.neutral'),
    },
  },
});

export const AssigneeItem = styled.div<{ zIndex: number }>(props => ({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 0,
  zIndex: props.zIndex,
  marginLeft: '-10px',

  '&:first-child': {
    marginLeft: 0,
  },

  /* On hover give it a z-index more than the number of assignees,
  to make sure that it always appear on top. */
  '&:hover, &:focus': {
    zIndex: MAX_ASSIGNEES_C0UNT + 10,
  },
}));

export const MoreAssigneesTrigger = styled(Button)({
  borderRadius: '50%',
  width: '36px',
  height: '36px',
  font: token('font.body.small'),
  padding: 0,
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: token('color.background.accent.gray.subtler'),
  border: `${BORDER_WIDTH}px solid ${token('color.border.inverse')}`,
  '&:hover, &:focus': {
    background: token('color.background.neutral'),
  },
});

export const AvatarBorder = styled.div<{ isSelected: boolean }>(props => ({
  borderRadius: '50%',
  border: `${BORDER_WIDTH}px solid transparent`,

  borderColor: props.isSelected
    ? token('color.border.information')
    : 'transparent',
}));

export const OptionContentContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const OptionLabelContainer = styled.div({
  marginLeft: token('space.100'),
});

export const MoreResultsLabelContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  color: token('color.text.subtle'),
  paddingTop: token('space.100'),
  paddingBottom: token('space.100'),
});
